import Newsletter_49_container from "./container/Newsletter_49_container";
export default Newsletter_49_container;
